import {PriceModel} from '../Price.model';
import {
  AppliedDiscountFragment,
  ComWixEcomTotalsCalculatorV1AppliedDiscountDiscountType,
} from '../../../../gql/graphql';
import {ModelContext} from '../../../../types/checkoutApp.types';
import {mapNullToUndefined} from '../../../utils/mapperHelper.utils';

export class AppliedCouponModel {
  /**
   * @deprecated
   */
  public couponType?: string;
  public discountType: DiscountType;
  public isFreeShippingCoupon: boolean;
  /**
   * @deprecated
   */
  public price: PriceModel;
  public code: string;
  public id: string;
  public name: string;

  constructor(params: AppliedCouponModel) {
    this.discountType = params.discountType;
    this.couponType = params.couponType;
    this.price = params.price;
    this.code = params.code;
    this.id = params.id;
    this.name = params.name;
    this.isFreeShippingCoupon = params.isFreeShippingCoupon;
  }

  public static fromCheckoutV1(appliedDiscounts: (AppliedDiscountFragment | null)[] = [], modelContext: ModelContext) {
    const discount = appliedDiscounts.find((discount) => discount?.coupon);
    const coupon = discount?.coupon;
    if (!coupon) {
      return undefined;
    }
    return new AppliedCouponModel({
      discountType: DiscountTypeMap[discount.discountType!],
      couponType: mapNullToUndefined(coupon.couponType),
      price: PriceModel.fromCheckoutV1(coupon.amount, modelContext),
      code: coupon.code!,
      id: coupon.id!,
      name: coupon.name!,
      isFreeShippingCoupon: discount?.discountType === ComWixEcomTotalsCalculatorV1AppliedDiscountDiscountType.SHIPPING,
    });
  }
}

export enum DiscountType {
  DELIVERY = 'DELIVERY',
  LINE_ITEM = 'LINE_ITEM',
  CART_SUBTOTAL = 'CART_SUBTOTAL',
}

const DiscountTypeMap: Record<ComWixEcomTotalsCalculatorV1AppliedDiscountDiscountType, DiscountType> = {
  [ComWixEcomTotalsCalculatorV1AppliedDiscountDiscountType.SHIPPING]: DiscountType.DELIVERY,
  [ComWixEcomTotalsCalculatorV1AppliedDiscountDiscountType.SPECIFIC_ITEMS]: DiscountType.LINE_ITEM,
  [ComWixEcomTotalsCalculatorV1AppliedDiscountDiscountType.GLOBAL]: DiscountType.CART_SUBTOTAL,
};
